export const DEFAULT_HEIGHT = '3.125rem' // 50px

export const COMMENT_LIMIT = 32000
